import Tree from "@/shared/data-display/tree";
import { arrayToTree } from "../utils/array-to-tree";
import { useMemo } from "react";
import { useCopyToClipboard } from "@uidotdev/usehooks";
import { message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { transformPropertyToInterpolatedProperty } from "@/shared/template-properties/utils/transform-property-to-interpolated-property";
import { useTranslations } from "use-intl";

export function PropertyTree({ properties }: { properties: string[] }) {
  const t = useTranslations("Common");

  const propertyMap = useMemo(() => {
    const propertyMap = new Map<string, boolean>();

    for (const property of properties) {
      propertyMap.set(property, true);
    }

    return propertyMap;
  }, [properties]);

  const tree = useMemo(() => arrayToTree(properties), [properties]);
  const [_, copy] = useCopyToClipboard();
  const [api, ContextHolder] = message.useMessage();

  return (
    <>
      <Tree
        treeData={tree}
        titleRender={(node) => {
          if (node.property !== null && propertyMap.get(node.property)) {
            return (
              <span>
                {node.title} <CopyOutlined />
              </span>
            );
          }

          return node.title;
        }}
        onSelect={async (_, { node }) => {
          if (node.property !== null && propertyMap.get(node.property)) {
            await copy(transformPropertyToInterpolatedProperty(node.property));
            await api.success(t("Copied to clipboard"));
          }
        }}
      />
      {ContextHolder}
    </>
  );
}
